<template lang="pug">
    div(@click="$emit('click')").ViewMoreButton
        el-button.ViewMoreButton-button(type="success" icon="el-icon-plus" circle)
        span.ViewMoreButton-button-text Ver más
</template>
<script>



export default {
  name: 'ViewMoreButton'  
}
</script>

<style scoped>
@import 'view-more-button.scss';
</style>
